var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessonsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 19.5H26C18.8305 19.5 13 25.3305 13 32.5V104C13 111.17 18.8305 117 26 117H52L40.3 132.6L50.7 140.4L68.25 117H87.75L105.3 140.4L115.7 132.6L104 117H130C137.17 117 143 111.17 143 104V32.5C143 25.3305 137.17 19.5 130 19.5ZM26 104V32.5H130L130.007 104H26Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78H65V91H39V78Z",
    fill: "#0066FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsIcon);
export default __webpack_public_path__ + "static/media/lessons_icon.a83f5e84.svg";
export { ForwardRef as ReactComponent };